// extracted by mini-css-extract-plugin
export var subtitle = "_au-2";
export var title = "_au-0";
export var titleNoWrap = "_au-1";